/**
 * Send email via backend Nodemailer API
 * @param {Object} formData - Contact or pricing form fields
 * @returns {Promise<{ success: boolean, message?: string }>}
 */
export const sendEmailViaBackend = async (formData) => {
  try {
    const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
    const res = await fetch(`${apiBaseUrl}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      return {
        success: false,
        message:
          data.message ||
          'Sorry, there was an error sending your message. Please try again.',
      };
    }

    return data;
  } catch {
    return {
      success: false,
      message: 'Sorry, there was an error sending your message. Please try again.',
    };
  }
};
